import { useAPI } from '@axo/shared/data-access/provider';
import { useQuery } from 'react-query';
import { puzzelKeys } from '../../cache-keys/puzzelKeys';
import { getPersonByS2ID } from '@axo/shared/data-access/api/puzzel';

export function useGetPersonByS2ID(s2ID: string | undefined) {
  const api = useAPI();
  const queryKey = puzzelKeys.personByS2ID(s2ID);

  return useQuery({
    queryKey,
    queryFn: () => getPersonByS2ID(api)(s2ID ?? ''),
    enabled: api.token.length > 0 && Boolean(s2ID),
  });
}
